/* eslint-disable max-len */
import React, { Component } from 'react';
import { t } from '../lib/i18n';
import sendJIEvent from '../lib/kwizzad-ji.jsx';
import externalPageTarget from '../lib/external-page-target';
import notifyCall2ActionReached from '../lib/notify-call2action-reached';
import { hadImpression } from '../lib/impressionTracking';
import isPageLoadedInsideIframe from '../lib/isPageLoadedInsideIframe';


const SvgArrow = () => (<svg className="arrow" width="72px" height="72px" viewBox="588 347 72 72" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(588.000000, 347.000000)">
        <path d="M36,0 C16.1223529,0 0,16.1223529 0,36 C0,55.8776471 16.1223529,72 36,72 C55.8776471,72 72,55.8776471 72,36 C72,16.1223529 55.8776471,0 36,0 L36,0 Z M46.9694118,38.4423529 C46.8,38.6117647 46.6023529,38.7670588 46.4047059,38.8941176 L32.8941176,52.4047059 C32.2447059,53.0682353 31.3835294,53.3929412 30.5223529,53.3929412 C29.6611765,53.3929412 28.8,53.0682353 28.1505882,52.4047059 C26.8376471,51.0917647 26.8376471,48.96 28.1505882,47.6470588 L39.7976471,36 L28.1929412,24.4235294 C26.88,23.1105882 26.88,20.9788235 28.1929412,19.6658824 C29.5058824,18.3529412 31.6376471,18.3529412 32.9505882,19.6658824 L46.4047059,33.12 C46.6023529,33.2470588 46.8,33.4023529 46.9694118,33.5717647 C47.6470588,34.2494118 47.9576471,35.1247059 47.9435294,36 C47.9576471,36.8894118 47.6470588,37.7647059 46.9694118,38.4423529 L46.9694118,38.4423529 Z" fill="#FFFFFF" />
    </g>
</svg>);



class ContinueButton extends Component {
    componentDidMount() {
        if (!this.props.challenge.X_DISMISS_WITHOUT_OPENING) {
            // This lets the native SDK know that the user sees the continue button
            sendJIEvent('call2Action');
        }

        if (!this.href) {
            this.notifyCall2ActionReached();
            return;
        }

        const isInWebSDK = isPageLoadedInsideIframe();


        // In a native SDK. Open URL that matches the goal URL to close the ad.
        // Note that this needs goal url === external page URL set in the campaign.

        // For the web SDK, it's enough to send notifyCall2ActionReached event to close the ad -
        // we want to leave it open normally though, as we can't automatically open a webpage in a
        // new window. In the web SDK, a 'Continue to the offer' button is shown to be able to
        // open a new page. For triggering the auto-close behavior, set X_DISMISS_WITHOUT_OPENING
        // to `true` in the challenge options.

        if (isInWebSDK) {
            if (this.props.challenge.X_DISMISS_WITHOUT_OPENING) {
                this.notifyCall2ActionReached();
            }
        } else {
            if (!this.props.challenge.X_DISMISS_WITHOUT_OPENING || hadImpression()) {
                window.open(this.href(), externalPageTarget());
                this.notifyCall2ActionReached();
            }
        }
    }

    notifyCall2ActionReached() {
        sendJIEvent('call2ActionClicked');
        notifyCall2ActionReached();
    }

    href() {
        return this.props.challenge.callToActionUrlWithRedirect;
    }

    render() {
        const href = this.href();
        if (this.props.challenge.X_DISMISS_WITHOUT_OPENING && !hadImpression()) {
            return (<div className="continueToOffer continueToOffer-small">
                <a // eslint-disable-line jsx-a11y/href-no-hash
                  href={isPageLoadedInsideIframe() ? '#' : href}
                  style={{ textAlign: 'left' }}
                  onClick={() => { this.notifyCall2ActionReached(); }}
                >
                    <div className="row">
                        <SvgArrow />
                        <header>{t('notAvailableAnymoreHeader')}</header>
                        <footer>{t('notAvailableAnymoreFooter')}</footer>
                    </div>
                </a>
            </div>)
        }
        return (<div className="continueToOffer">
            <a
              href={href}
              ref={link => this.link = link} // eslint-disable-line no-return-assign
              target={externalPageTarget()}
              onClick={() => { this.notifyCall2ActionReached(); }}
            >
                <div className="row">
                    <SvgArrow />
                    <header>{t('continueHeader')}</header>
                    <footer>{t('continueFooter')}</footer>
                </div>
            </a>
        </div>);
    }
}

export default ContinueButton;



// WEBPACK FOOTER //
// ./src/campaign/continue-button.jsx